function calculateProgressBarWidth(thresholdData) {
    const { points, steps } = thresholdData;

    // Sprawdzanie, czy punkty mieszczą się w zakresie progów
    const lastStep = steps[steps.length - 1].value;
    if (points >= lastStep) {
        return 100;
    }

    // Znalezienie aktualnego progu
    const currentStepIndex = steps.findIndex((step) => points < step.value);
    // Index progu w którym próg jest większe niż punkty, jest to aktualny próg
    const currentStep = steps[currentStepIndex];
    // Aktualny index progu jest większy od zera to wybierz wartosc z indexu poprzedniego progu lub wartość zero
    const previousStep = currentStepIndex > 0 ? steps[currentStepIndex - 1] : { value: 0 };
    console.log(`${currentStep.value} wartość aktualnego progu`);
    console.log(`${previousStep.value} wartość poprzedniego progu`);
    console.log(`${steps.length} ilość progów`);
    console.log(`${points} aktualna liczba punktów`);
    console.log(
        `${points} - ${previousStep.value} / ${currentStep.value} - ${previousStep.value} `
    );

    // Obliczanie szerokości dla aktualnego progu
    const progressWithinStep =
        // eg. (6500 - 5000) / (10000 - 5000)
        (points - previousStep.value) / (currentStep.value - previousStep.value);
    const segmentWidth = 100 / (steps.length - 1); // Dzieląc na równomierne segmenty
    console.log(`100 / ${steps.length - 1} = ${Math.round(segmentWidth)}`);

    const result =
        (currentStepIndex - 1) * Math.round(segmentWidth) +
        progressWithinStep * Math.round(segmentWidth);

    console.log(
        `${currentStepIndex - 1} * ${Math.round(
            segmentWidth
        )} + ${progressWithinStep} * ${Math.round(segmentWidth)} = ${result} wynik funkcji`
    );
    return (currentStepIndex - 1) * segmentWidth + progressWithinStep * segmentWidth;
}
const pointWordChanger = (points) => {
    if (points === 1) {
        return 'punkt';
    }
    if (points > 1 && points < 5) {
        return 'punkty';
    }
    return 'punktów';
};

function updateClassesBasedOnDataValue(points) {
    const elements = document.querySelectorAll('[data-active-above-value]');
    elements.forEach((element) => {
        const value = parseInt(element.getAttribute('data-active-above-value'), 10);
        if (value <= points || value === 0) {
            element.classList.add('active');
        } else {
            element.classList.remove('active');
        }
    });
}

function updateProgressBarUI(data) {
    const isDesktop = window.innerWidth >= 992;

    const progressBarSelector = isDesktop ? '.current-progress-desktop' : '.current-progress';
    const pointsDisplaySelector = isDesktop
        ? '.current-points-display-desktop'
        : '.current-points-display';

    const progressBar = document.querySelector(progressBarSelector);
    const pointsDisplay = document.querySelector(pointsDisplaySelector);
    const numberOfPoints = document.querySelector(
        isDesktop ? '.current-points-desktop' : '.current-points'
    );
    const pointWord = document.querySelector(isDesktop ? '.point-word-desktop' : '.point-word');
    const progressBarValue = calculateProgressBarWidth(data);
    const progressBarDimension = `${progressBarValue}%`;

    numberOfPoints.innerText = data.points;
    pointWord.innerText = pointWordChanger(data.points);

    if (isDesktop) {
        const pointsDisplayDimension = `calc(${progressBarValue}% - ${
            pointsDisplay.clientWidth / 2
        }px)`;
        pointsDisplay.style.left = pointsDisplayDimension;
        progressBar.style.width = progressBarDimension;
    } else {
        const pointsDisplayDimension = `calc(${progressBarValue}% - ${
            pointsDisplay.clientHeight / 2
        }px)`;
        pointsDisplay.style.top = pointsDisplayDimension;
        progressBar.style.height = progressBarDimension;
    }

    updateClassesBasedOnDataValue(data.points);
}

export const loyalityPointsProgressBar = (data) => {
    updateProgressBarUI(data);
};
